import React from 'react';
import Box from '../../../../../../components/Box';
import Paper from '../../../../../../components/Paper';
import Search from '../../../../../../components/Search';
import Typography from '../../../../../../components/Typography';
import User from '../../../../../../components/User';
import { makeStyles } from '../../../../../../utils/styles';
import { getImageUrl } from '../../../../../../utils/helpers';
import { ChatListStyled, ChatItemStyled } from './styled';
import { format, fromUnixTime } from 'date-fns';
import ScrollArea from '../../../../../../components/ScrollArea';
import Loader from '../../../../../../components/Loader';
import IconButton from '../../../../../../components/IconButton';
import Icon from '../../../../../../components/Icon';
import Badge from '../../../../../../components/Badge';
import useTheme from "../../../../../../hooks/useTheme";
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(css => ({
    paper: css`
        position: relative;
        overflow: hidden;
        padding: 0;
    `,
    box: css`
        display: flex;
        align-items: center;
        padding: 20px 20px 10px 20px;
    `,
    button: css`
        margin-left: 10px;
    `,
    listBox: css`
        flex-shrink: 1;
        flex-grow: 1;
        margin-top: 10px;
        margin-left: 20px;
        margin-right: 20px;
    `,
    listBoxTitle: css`
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 5px;
    `,
    listBoxText: css`
        font-size: 12px;
        line-height: 16px;
        color: ${({ theme }) => theme.colors.grey};
        margin-bottom: 5px;
    `,
    dot: css`
        margin-top: 10px;
        width: 10px;
        min-width: 10px;
        height: 10px;
        background-color: ${({ theme }) => theme.colors.blue};
        border-radius: 50%;
    `
}));

const ChatList = ({ activeUser, users, searchText, showLoader, showUnreadMessages, onClickUser, onChangeSearch, onClickUnreadMessages }) => {
    const { t } = useTranslation()
    const styles = useStyles();
    const theme = useTheme();

    return (
        <Paper customStyle={styles.paper}>
            <Box customStyle={styles.box}>
                <Search
                    value={searchText}
                    onChange={onChangeSearch}
                    fullWidth
                />
                <IconButton
                    customStyle={styles.button}
                    onClick={onClickUnreadMessages}
                    title={showUnreadMessages ? t("Pokaż wszystkie") : t("Pokaż nieprzeczytane")}
                >
                    <Badge
                        invisible={showUnreadMessages}
                        size="large"
                        border
                        offsetTop={6}
                    >
                        <Icon name="message" height={16.5} width={24.5} />
                    </Badge>
                </IconButton>
            </Box>
            <ChatListStyled>
                <ScrollArea
                    heightModifiers={{
                        isCalc: true,
                        offset: 40
                    }}
                >
                    {
                        (users && users.length > 0) && users.map(user => (
                            <ChatItemStyled
                                key={user.id}
                                onClick={onClickUser(user.id)}
                                active={parseInt(user.id, 10) === parseInt(activeUser?.id, 10)}
                            >
                                <User
                                    user={{
                                        avatarSrc: getImageUrl(user?.avatar?.url),
                                        rating: user?.rankings
                                    }}
                                    interactive
                                    hideDelete
                                />
                                <Box customStyle={styles.listBox}>
                                    <Typography customStyle={styles.listBoxTitle} font={user?.is_unread ? theme.fonts.mulishBold : theme.fonts.mulishRegular}>{user?.first_name}</Typography>
                                    <Typography customStyle={styles.listBoxTitle} font={user?.is_unread ? theme.fonts.mulishBold : theme.fonts.mulishRegular}>{user?.last_name}</Typography>
                                    {
                                        user?.last_job &&
                                        <>
                                            <Typography customStyle={styles.listBoxText}>{t("Ostatnie zlecenie {{date}}", { date: format(fromUnixTime(user?.last_job?.time_start), 'dd.MM.yyyy') })}</Typography>
                                            <Typography customStyle={styles.listBoxText}>{user?.last_job?.profession_name}</Typography>
                                        </>
                                    }
                                    {
                                        (user?.isNewCandidate && !user?.last_job) &&
                                        <Typography customStyle={styles.listBoxText}>{t("Nowy pracownik")}</Typography>
                                    }
                                </Box>
                                {user?.is_unread && <Box customStyle={styles.dot} />}
                            </ChatItemStyled>
                        ))
                    }
                    {(users && users.length === 0) &&
                        <Box customStyle={styles.listBox}>
                            <Typography>{t("Brak użytkowników")}</Typography>
                        </Box>
                    }
                </ScrollArea>
            </ChatListStyled>
            <Loader show={showLoader} />
        </Paper>
    )
}

export default ChatList;
